import { apiClient } from "client/utils";

export type MarqetaAccessToken = {
  accessToken: string;
};

export type HasSelfServeActivated = { hasSelfServeTransaction: boolean };

export const getMarqetaClientAccessToken = async (
  storeLocationId?: string
): Promise<MarqetaAccessToken> => {
  if (!storeLocationId) {
    return Promise.reject(new Error("storeLocationId is required"));
  }
  return apiClient<MarqetaAccessToken>(
    `/api/instore/client-access-token?store_location_id=${storeLocationId}`
  );
};

export const getHasSelfServeInstoreActivation = async (
  storeLocationId?: string
): Promise<HasSelfServeActivated> =>
  apiClient<HasSelfServeActivated>(
    `/api/instore/store-location/${storeLocationId}`
  );
